import { EventName } from '@jumbo/constants/electron/EventName';
import {
  GET_ACCOUNTS,
  OPEN_BROWER_SUCCESS,
  CLOSE_BROWER_SUCCESS,
  CLOSING_BROWER,
  OPENING_BROWER,
  UPDATE_ACCOUNTS,
  SELECTED_ACCOUNT,
  ADD_LIST_ACCOUNT,
  REMOVE_LIST_ACCOUNT,
  SELECTED_DEFAULT,
  SET_ACCOUNTS_FOR_ACTION,
  REMOVE_ACCOUNT_FOR_ACTION,
  CLOSE_ALL_BROWSER,
  SET_ACCOUNT_SHARED,
  SET_ACCOUNT_SHARE_WITH_ME,
  SET_SCAN_ACCOUNT,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  dataAccounts: [],
  selectedAccount: [],
  listAccountAction: [],
  selectedAccountDefault: {
    start: 0,
    end: 0,
  },
  accountsForAction: [],
  accountShared: [],
  accountShareWithMe: [],
  accountsIndex: {},
  accountSharesIndex: {},
  isClean: false,
  scanAccount: {
    error: 0,
    success: 0,
    total: 0,
  },
};

const { ipcRenderer } = window.require('electron');

function onUpdateAccount(index, account, array) {
  for (const key in account) {
    array[index][key] = account[key];
  }
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ACCOUNTS: {
      let dataAccounts = action.payload.map((item, index) => {
        let account = state.dataAccounts.find(itemState => itemState._id == item._id);
        return {
          state: 0,
          ...account,
          ...item,
          isSelected: false,
          index: index
        }
      });

      return {
        ...state,
        dataAccounts: dataAccounts,
      };
    }
    case UPDATE_ACCOUNTS: {
      let isUpdateMyAccount = false;
      let dataAccounts = state.dataAccounts.map(account => {
        if (account._id == action.payload._id) {
          isUpdateMyAccount = true;
          return {
            ...account,
            ...action.payload,
          };
        }
        return account;
      });

      if (isUpdateMyAccount) {
        return {
          ...state,
          dataAccounts,
        };
      }

      let isChangeAccountShare = false;
      let accountShares = state.accountShareWithMe.map(account => {
        if (account._id == action.payload._id) {
          isChangeAccountShare = true;
          return {
            ...account,
            ...action.payload,
          };
        }
        return account;
      });

      if (isChangeAccountShare) {
        return {
          ...state,
          accountShareWithMe: accountShares,
        };
      }
      return {
        ...state,
      };
    }
    case OPEN_BROWER_SUCCESS:
    case OPENING_BROWER:
    case CLOSE_BROWER_SUCCESS:
    case CLOSING_BROWER: {
      let id = action.payload._id;
      let isChangeMyAccounts = false;
      let dataAccounts = state.dataAccounts.map(item => {
        if (item._id == id) {
          item.state = action.payload.state;
          isChangeMyAccounts = true;
        }
        return item;
      });

      if (isChangeMyAccounts) {
        return {
          ...state,
          dataAccounts,
        };
      }
      let isChangeAccountShareWithMe = false;

      let accountShares = state.accountShareWithMe.map(item => {
        if (item._id == id) {
          item.state = action.payload.state;
          isChangeAccountShareWithMe = true;
        }
        return item;
      });
      if (isChangeAccountShareWithMe) {
        return {
          ...state,
          accountShareWithMe: accountShares,
        };
      }

      return {
        ...state,
      };
    }
    case SELECTED_ACCOUNT: {
      let { selectedAccount } = action.payload;
      return {
        ...state,
        selectedAccount: [...selectedAccount],
      };
    }
    case ADD_LIST_ACCOUNT: {
      return {
        ...state,
        listAccountAction: [...state.listAccountAction, action.payload],
      };
    }
    case REMOVE_LIST_ACCOUNT: {
      let index = state.listAccountAction.findIndex(item => item._id === action.payload._id);
      state.listAccountAction.splice(index, 1);
      return {
        ...state,
        listAccountAction: [...state.listAccountAction],
      };
    }
    case SELECTED_DEFAULT: {
      return {
        ...state,
        selectedAccountDefault: action.payload,
      };
    }
    case SET_ACCOUNTS_FOR_ACTION: {
      return {
        ...state,
        accountsForAction: [...state.accountsForAction, action.payload],
      };
    }
    case CLOSE_ALL_BROWSER: {
      let dataAccounts = state.dataAccounts.map(account => {
        if (account.state !== 0 || account.state !== undefined) {
          let _id = account._id;
          ipcRenderer.send(`${EventName.CloseBrowser}:${_id}`, { _id });
        }
        account.state = 0;
        return account;
      });

      let accountShareWithMe = state.accountShareWithMe.map(account => {
        if (account.state !== 0 || account.state !== undefined) {
          let _id = account._id;
          ipcRenderer.send(`${EventName.CloseBrowser}:${_id}`, { _id });
        }
        account.state = 0;
        return account;
      });
      return {
        ...state,
        dataAccounts: dataAccounts,
        accountShareWithMe: accountShareWithMe,
        accountsForAction: [],
      };
    }
    case REMOVE_ACCOUNT_FOR_ACTION: {
      let accountsForAction = state.accountsForAction;
      accountsForAction.splice(action.payload, 1);
      return {
        ...state,
        accountsForAction: [...accountsForAction],
      };
    }
    case SET_ACCOUNT_SHARED: {
      return {
        ...state,
        accountShared: action.payload,
      };
    }
    case SET_ACCOUNT_SHARE_WITH_ME: {
      let accountShares = action.payload;
      let accountSharesIndex = state.accountSharesIndex;
      if (state.accountShareWithMe.length) {
        accountShares = action.payload.map((account, index) => {
          if (typeof accountSharesIndex[account._id] == 'number') {
            let result = {
              ...state.accountShareWithMe[accountSharesIndex[account._id]],
              ...account,
            };
            accountSharesIndex[account._id] = index;
            return result;
          }
          accountSharesIndex[account._id] = index;
          return account;
        });
      } else {
        accountShares.map((account, index) => {
          accountSharesIndex[account._id] = index;
        });
      }
      return {
        ...state,
        accountShareWithMe: accountShares,
        accountSharesIndex,
      };
    }
    case SET_SCAN_ACCOUNT: {
      return {
        ...state,
        scanAccount: {
          error: state.scanAccount.error + action.payload.error || 0,
          success: state.scanAccount.success + action.payload.success || 0,
          total: action.payload.total || 0,
        },
      };
    }
    default:
      return state;
  }
};
